import type { SxProps, Theme } from "@mui/material";

// Shared translucent "glass" surface so UI chrome (tabs, toolbar) stays legible
// over the busy background image without hiding it entirely.
export const glassPanelSx: SxProps<Theme> = {
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
  border: "1px solid rgba(0, 0, 0, 0.08)",
  borderRadius: 2,
};
